import type { HomePage } from '../model/HomePage';

export const DefaultFallBack: HomePage = {
    name: 'DefaultFallBack',
    widgets: [ 'RecommendationTemplates', 'Automations', 'Runs' ],
    persona: 'UNKNOWN',
    featureFlag: 'HomePage-DefaultFallBack',
};
